module.exports = __webpack_public_path__ + "img/add-arrival-climbing-table-icon.27e665b8.svg";